import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Icon } from 'app/shared/components/atoms';
import { ReactComponent as Check } from 'icons/check.svg';

import { Option, SharedOptionsProps } from '.';

export interface SimpleOptionsProps<T> extends SharedOptionsProps<T> {
  onOptionClick: (option: T) => void;
  selectedOption?: string | number;
}

export const SimpleOptions = <T = any,>({
  onOptionClick,
  options,
  getOptionLabel,
  getOptionValue,
  invertColors,
  selectedOption,
}: SimpleOptionsProps<T>) => {
  const { colors } = useCurrentTheme();

  const optionsList = options.map((option: T, index: number) => {
    const value = getOptionValue(option);
    const label = getOptionLabel(option);
    const isSelected = selectedOption === label;

    return (
      <Option
        data-qaid={label}
        key={String(value)}
        value={value}
        onClick={() => onOptionClick(option)}
        invertColors={invertColors}
        isSelected={isSelected}
        isLastChild={index === options.length - 1}
        gap={2}
      >
        {isSelected && (
          <Icon
            icon={Check}
            size="sm"
            strokeColor={
              invertColors
                ? colors.primary.white.base
                : colors.primary.black.base
            }
          />
        )}
        {label}
      </Option>
    );
  });

  return <>{optionsList}</>;
};

export default SimpleOptions;
